import { useState, useEffect } from 'react';
import { Grid } from '@material-ui/core';
import styles from 'assets/styles/training.module.scss';
import styles_ from './SkillPaths.module.scss';
import 'react-circular-progressbar/dist/styles.css';
import Shimmer from '../Shimmer';
import SkillPathChart from './SkillPathChart';
import UserTypeChart from './UserTypeChart';
import { format, parseISO } from 'date-fns';
import UserAvatars from '../LearningPaths/Components/LearningPathDetails/UserAvatars';
import TotalUsersChart from './TotalUsersChart';
import {
  useGetSkillPathsTotal,
  useGetUserTypeDetails,
  useGetSkillPathTotalUsersProgress,
  useGetSkillPathDetails,
} from 'features/training/Training.queries';
import { CustomButton } from 'shared_ui_components';

const SkillPathsDashboardAdmin = ({ff_skill_paths_dashboards = false}) => {
  const [count, setCount] = useState(1);
  
  const { data: skillPathTotal = {}, isLoading: isLoadingSkillPathTotal } = useGetSkillPathsTotal({
    enabled: true,
  });

  const { data: skillPathUserTypeDetails = {}, isLoading: isLoadingSkillPathUserTypeDetails } =
    useGetUserTypeDetails({
      enabled: ff_skill_paths_dashboards,
    });

  const {
    data: skillPathTotalUsersProgress = {},
    isLoading: isLoadingSkillPathTotalUsersProgress,
  } = useGetSkillPathTotalUsersProgress({
    enabled: ff_skill_paths_dashboards,
  });

  const {
    data: skillPathDetails = {},
    isLoading: isLoadingSkillPathDetails,
    refetch: refetchSkillPathDetails,
    isFetching: isFetchingSkillPathDetails,
  } = useGetSkillPathDetails({
    enabled: ff_skill_paths_dashboards,
    page: count,
  });
  useEffect(() => {
    refetchSkillPathDetails();
  }, [count]);

  const handleViewMore = () => {
    setCount((prevCount) => prevCount + 1);
  };
  const handleBack = () => {
    setCount((prevCount) => prevCount - 1);
  };

  if (
    isLoadingSkillPathTotal ||
    isLoadingSkillPathUserTypeDetails ||
    isLoadingSkillPathTotalUsersProgress ||
    isLoadingSkillPathDetails
  )
    return (
      <div>
        {' '}
        <Shimmer type="ModuleCard" />
      </div>
    );
  return (
    <>
      <br />
      {/* <div className={styles_.upskillOverviewCharts}> */}
      <Grid container spacing={1}>
        <Grid item md={6} lg={4} xs={12}>
          {Object.keys(skillPathTotal) && (
            <SkillPathChart title={`Skill Paths`} progress={{ ...skillPathTotal?.data }} />
          )}
        </Grid>
        <Grid item md={6} lg={4} xs={12}>
          {Object.keys(skillPathTotalUsersProgress) && (
            <TotalUsersChart
              title={`Total Users`}
              users={{ ...skillPathTotalUsersProgress?.data }}
            />
          )}
        </Grid>
        <Grid item md={6} lg={4} xs={12}>
          {Object.keys(skillPathUserTypeDetails) && (
            <UserTypeChart title={`User Type`} users={{ ...skillPathUserTypeDetails?.data }} />
          )}
        </Grid>
      </Grid>

      {/* </div> */}
      <br />
      <section className={`${styles.moduleDetails} dashboardListing`}>
        {Object.keys(skillPathDetails?.data?.data?.learning_paths).length > 0 ? (
          <Grid container direction="row">
            <Grid md={12}>
              <div className="teamProgressWrapper">
                <Grid container direction="row" spacing={4} className="headingRow">
                  <Grid item md={5}>
                    <h3 className="heading5">Skill Path Details</h3>
                  </Grid>
                </Grid>
                <div className="teamProgressDetail">
                  <Grid container direction="row" spacing={4} className="titleRow">
                    <Grid item md={3}>
                      <h6 className="supportTextSemibold">NAME</h6>
                    </Grid>
                    <Grid item md={2}>
                      <h6 className="supportTextSemibold">AUTHOR</h6>
                    </Grid>
                    <Grid item md={1}>
                      <h6 className="supportTextSemibold">SKILL SETS</h6>
                    </Grid>
                    <Grid item md={1}>
                      <h6 className="supportTextSemibold">UPDATED DATE</h6>
                    </Grid>
                    <Grid item md={1}>
                      <h6 className="supportTextSemibold">DUE</h6>
                    </Grid>
                    <Grid item md={2}>
                      <h6 className="supportTextSemibold">PARTICIPANTS</h6>
                    </Grid>
                    <Grid item md={2}>
                      <h6 className="supportTextSemibold">STATUS</h6>
                    </Grid>
                  </Grid>
                  <div className="contentBlock">
                    {skillPathDetails?.data?.data?.learning_paths.map((skillPath) => (
                      <SkillPathRegister skillPath={skillPath} key={skillPath.id} />
                    ))}
                  </div>
                  {skillPathDetails?.data?.data?.pagination?.next ||
                  skillPathDetails?.data?.data?.pagination?.previous ? (
                    <div className={styles.viewMoreBtn}>
                      <p className={styles_.navigationButton} style={{ margin: '24px 0 8px' }}>
                        {skillPathDetails?.data?.data?.pagination?.previous && (
                          <CustomButton className="secondaryBtn" onClick={handleBack}>
                            {isFetchingSkillPathDetails ? 'Loading...' : 'Previous Page'}
                          </CustomButton>
                        )}
                        {skillPathDetails?.data?.data?.pagination?.next && (
                          <CustomButton className="secondaryBtn" onClick={handleViewMore}>
                            {isFetchingSkillPathDetails ? 'Loading...' : 'Next Page'}
                          </CustomButton>
                        )}
                      </p>
                    </div>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            </Grid>
          </Grid>
        ) : (
          <div className={styles_.noSkillPathHistory}>
            <div>Your Skill Path Details will show here</div>
          </div>
        )}
      </section>
    </>
  );
};

export function SkillPathRegister(props) {
  const { skillPath = {} } = props;

  return (
    <div className="item">
      <Grid container direction="row" spacing={4} className="item">
        <Grid item md={3}>
          <h6 className="supportTextSemibold">{skillPath?.title}</h6>
        </Grid>
        <Grid item md={2}>
          <h6 className="supportTextSemibold">{skillPath?.author}</h6>
        </Grid>
        <Grid item md={1}>
          <h6 className="supportTextSemibold">{skillPath?.modules_count}</h6>
        </Grid>
        <Grid item md={1}>
          {skillPath?.updated_at ? (
            <h6 className="supportTextSemibold">
              {format(parseISO(skillPath?.updated_at), 'dd/MM/yyyy')}
            </h6>
          ) : (
            <div> - - </div>
          )}
        </Grid>
        <Grid item md={1}>
          {skillPath?.deadline ? (
            <h6 className="supportTextSemibold">
              {format(parseISO(skillPath?.deadline), 'dd/MM/yyyy')}
            </h6>
          ) : (
            <div> - - </div>
          )}
        </Grid>
        <Grid item md={2}>
          <UserAvatars users={skillPath?.participants?.preview} />
        </Grid>
        <Grid item md={2}>
          <h6
            className={
              skillPath?.status.key === 'completed'
                ? styles_.completedStatus
                : skillPath?.status.key === 'in_progress'
                ? styles_.in_progress
                : styles_.not_started
            }
          >
            {skillPath?.status.label}
          </h6>
        </Grid>
      </Grid>
    </div>
  );
}
export default SkillPathsDashboardAdmin;
